export default () => {
	var CommonQuote = {};
	CommonQuote.$ = jQuery;

	CommonQuote.quotes = [];
	CommonQuote.selectedQuote = [];

	CommonQuote.init = function () {
		var $ = CommonQuote.$;

		CommonQuote.form = $('.js-quickquoteform');
		CommonQuote.quoteWidgetStep1 = $('.js-quotetemplate');
		CommonQuote.step2Results = $('.js-results');

	};

	CommonQuote.populateQuoteEl = function (quoteData) {
		var template = $('.js-quotetemplate');
		template.find('.js-quote').each(function (index) {
			if (
				quoteData.deliveryType == parseInt($(this).data('deliverytype')) &&
				quoteData.pickUpType == parseInt($(this).data('pickuptype'))
			) {

				$(this).find('[data-servicetype=' + quoteData.service + '] .js-quote-cost').html(quoteData.totalNice);
				$(this).find('[data-servicetype=' + quoteData.service + '] .js-transit-days').html('Transit Days: ' + quoteData.transitDays);
				$(this).find('.js-quotepickup').html('<i>' + quoteData.pickUp + '</i>').addClass('locationtype-' + quoteData.pickUpType);
				$(this).find('.js-quotedelivery').html('<i>' + quoteData.delivery + '</i>').addClass('locationtype-' + quoteData.deliveryType);
				// var quoteInput = $(this).find('.js-quoteselection');
				// var quoteInputLabel = $(this).find('.js-quoteselectionlabel');
				var quoteInput = $(this).find('[data-servicetype=' + quoteData.service + ']').find('.js-quoteselection');
				var quoteInputLabel = $(this).find('[data-servicetype=' + quoteData.service + ']').find('.js-quoteselectionlabel');
				quoteInput.val(quoteData.uniqueId);
				quoteInput.attr('id', 'Quote-' + quoteData.uniqueId);
				$(this).find('[data-servicetype=' + quoteData.service + ']').addClass('visible');

				quoteInput.on('change', function (ev) {
					CommonQuote.updateQuoteSelection();
				});
				quoteInputLabel.attr('for', 'Quote-' + quoteData.uniqueId);

			}

		});
	};

	CommonQuote.updateQuoteSelection = function () {
		var $ = CommonQuote.$;

		// var selectedEl1 = CommonQuote.quoteWidgetStep1.find('.js-quoteselection');
		var selectedEl = CommonQuote.quoteWidgetStep1.find('.js-quoteselection:checked');

		//Add class to selected quote
		CommonQuote.quoteWidgetStep1.find('.js-quote').removeClass('active');
		selectedEl.parents('.js-quote').addClass('active');

		var quoteId = selectedEl.val();


		var quoteData = CommonQuote.getQuoteById(quoteId);
		var trkService = (typeof quoteData.service == 'string') && quoteData.service.length ? quoteData.service : 'Not Set';
		// gtag('event', 'quote selection', {event_category: 'quote', event_label: trkService});


		if (quoteData) {
			CommonQuote.selectedQuote = quoteData;

			$.ajax({
				type: "POST",
				url: 'quote/selectQuickQuote',
				data: {
					SelectedQuote: quoteData,
				},
				dataType: 'json',
				success: function (data) {

				}
			});

		}
	};

	CommonQuote.setLocationType = function (direction, type, reset, fromQuote) {
		var $ = CommonQuote.$;
		var selectorPrefix = '.js-' + direction;
		var fromQuote = !!fromQuote;

		//Get reusable elements
		var address1Input = CommonQuote.form.find(selectorPrefix + 'address1');
		var address2Input = CommonQuote.form.find(selectorPrefix + 'address2');
		var depotInput = CommonQuote.form.find(selectorPrefix + 'depot');
		var typeInput = CommonQuote.form.find(selectorPrefix + 'type');
		var suburbInput = CommonQuote.form.find(selectorPrefix + 'suburb');
		var stateInput = CommonQuote.form.find(selectorPrefix + 'state');
		var postcodeInput = CommonQuote.form.find(selectorPrefix + 'postcode');
		var addressWrapperEl = CommonQuote.form.find(selectorPrefix + 'addresswrapper');
		var depotWrapperEl = CommonQuote.form.find(selectorPrefix + 'depotwrapper');

		//Get currently selected type if not provided to method.
		if (!type) {
			var type = typeInput.val() == '0' ? 'depot' : 'address';
		}

		//Reset field values
		if (reset) {
			address1Input.val('');
			address2Input.val('');
			depotInput.val('');
			suburbInput.val('');
			stateInput.val('');
			postcodeInput.val('');
		}


		//Lock/unlock, hide/show according to type
		if (type == 'depot') {
			typeInput.val('0');
			suburbInput.attr('disabled', true);
			addressWrapperEl.hide();
			depotWrapperEl.show();
		} else if (type == 'address') {
			typeInput.val('1');
			suburbInput.attr('disabled', false);
			addressWrapperEl.show();
			depotWrapperEl.hide();
		}

		//Common to both
		stateInput.attr('disabled', true);
		postcodeInput.attr('disabled', true);

		//Lock fields that shouldn't be editable after selecting a quote.
		CommonQuote.form.find(selectorPrefix + 'quotedfieldslocked').toggle(fromQuote);
		typeInput.attr('disabled', fromQuote);
		depotInput.attr('disabled', fromQuote);
		suburbInput.attr('disabled', fromQuote);
		if (!fromQuote && type == 'address') {
			suburbInput.attr('disabled', false);
		}
		if (!fromQuote && type == 'depot') {
			suburbInput.attr('disabled', true);
		}
	};

	CommonQuote.updateDepotLocation = function (direction, depotCode) {
		var selectorPrefix = '.js-' + direction;
		if (!depotCode) {
			var depotCode = $(selectorPrefix + 'depot').val();
		}
		if (depotCode) {
			var depot = CommonQuote.getDepotDetails(depotCode);
			if (depot) {
				$(selectorPrefix + 'suburb').val(depot.DepotAddress.Suburb.SuburbName);
				$(selectorPrefix + 'state').val(depot.DepotAddress.Suburb.State);
				$(selectorPrefix + 'postcode').val(depot.DepotAddress.Suburb.PostCode);
			}
		}
	};

	CommonQuote.getDeliveryLocation = function () {
		return CommonQuote.getLocationAsObject('delivery');
	};

	CommonQuote.getDepotDetails = function (code) {
		var depot = {};
		$.ajax({
			async: false,
			type: "POST",
			url: 'quote/getDepotDetails',
			data: {DepotCode: code},
			dataType: 'json',
			success: function (data) {
				depot = data;
			}
		});
		return depot;
	};

	CommonQuote.getLocationAsObject = function (direction) {
		var selector = '.js-' + direction + 'location';
		var val = CommonQuote.$(selector).val();
		var parts = val.split(',');
		var parts = $.map(parts, function (part) {
			return part.trim();
		});
		if (parts.length != 3) {
			$.error("Pick Up and Delivery location does not have all three required parts.");
			return false;
		}
		return {
			'suburb': parts[0],
			'state': parts[1],
			'postcode': parts[2]
		};
	};

	CommonQuote.populateNullQuote = function () {
		var template = $('.js-quotetemplate');
		template.find('.cost-col').each(function (index, quoteCell) {
			if (!$(quoteCell).hasClass('visible')) {
				$(quoteCell).html('N/A');
				$(quoteCell).addClass('visible');
			}
		});
	};

	CommonQuote.getQuoteById = function (id) {
		var $ = CommonQuote.$;
		if (CommonQuote.quotes && CommonQuote.quotes.length) {
			var matching = $.grep(CommonQuote.quotes, function (quoteData) {
				return quoteData.uniqueId == id;
			});
			if (matching.length) {
				return matching[0];
			}
		}
		return false;
	};


	(function ($) {
		//Dom ready
		$(function () {
			CommonQuote.init();
		});
	})(jQuery);
}
